export default {
    path: '/trademarks',
    name: 'trademarks',
    component: () => import('source/pages/TrademarksPage.vue'),
    props: true,
    meta: {
        title: 'Trademarks - HQZen',
        loginRequired: false,
    },
};
